<template>
  <div class="protocal-component-protocol">
    <div class="btn-group">
      <div class="search-hd">
        <el-button type="primary" @click="onAdd">
          <i class="el-icon-plus el-icon--left"></i>
          {{ $t('dms_protocol_component_protocol.xuan_ze_xie_yi') }}
        </el-button>
        <!-- <el-button
          style="float:right;"
          class="table-set"
          @click="exportTable"
        ><i class="icon icon-daochu"></i></el-button> -->
        <!-- <search-input
          style="float:right;"
          class="search"
          v-model="search"
          @fetch="onFetch"
          :placeholder="$t('placeholder_protocol_search')"
        ></search-input> -->
      </div>
    </div>
    <div class="table-bd">
      <custom-table :data="tableList" @row-click="onRowClick" :column="tableColumn" index @sort="sortChange" :slots="['action']">
        <template v-slot:action="scope">
          <span>
            <el-button type="text" size="mini" @click.stop="onDel(scope.row)">{{ $t('Common.com_delete') }}</el-button>
          </span>
        </template>
      </custom-table>
    </div>
    <!-- 添加协议dialog -->
    <product-addProtocol-dialog @success="onSuccess" v-if="addProtocolDialog" @close="addProtocolDialog = false" :model="addProtocolModel"></product-addProtocol-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import productAddProtocolDialog from './product_addProtocol_dialog.vue';

export default {
  components: {
    productAddProtocolDialog,
  },
  props: {
    productSn: String,
  },
  provide() {
    return {
      showTopicDetail: this.showTopicDetail,
    };
  },
  data() {
    return {
      tableCode: 'product_protocol',
      tableList: [],
      addProtocolDialog: false,
      addProtocolModel: {},
      editModel: {},
    };
  },
  watch: {
    productSn: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getTableList();
        }
      },
    },
  },
  methods: {
    onRowClick(row) {
      this.$emit('row-click', row);
    },
    onAdd() {
      this.addProtocolModel.type = 'add';
      this.addProtocolModel.title = this.$t('dms_protocol_component_protocol.xuan_ze_xie_yi');
      this.addProtocolModel.productSn = this.productSn;
      this.addProtocolDialog = true;
    },
    onDel(row) {
      this.$showConfirm(this.$t('dms_protocol_component_protocol.nqdyscxzdxym')).then(() => {
        this.$postJSON(`${apis.productProtocolDelete}/${row.productProtocolId}`).then(() => {
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success',
          });
          // this.$emit('delete', row);
          // this.$emit('change', row);
          this.getTableList();
        });
      });
    },
    getTableList() {
      this.$getJSON(apis.productProtocolList, {
        productSn: this.productSn,
      }).then((res) => {
        this.tableList = res.data;
      });
    },
    onSuccess() {
      // this.$emit(type, this.editModel.data);
      // this.$emit('change', this.editModel.data);
      this.getTableList();
    },
  },
  mounted() {
    this.getTableColumn();
  },
};
</script>

<style lang="scss">
.protocal-component-protocol {
  .search-hd {
    padding-top: 0;
  }
  .btn-group {
    overflow: hidden;
  }
  .search {
    float: right;
  }
}
</style>
